export var selectUserHasFolders = function selectUserHasFolders(state) {
  return state.favoritesAssignWidget.userHasFolders;
};